export const templateBase = {
  templateType: null,
  senderKey: null,
  templateCode: null,
  newSenderKey: null,
  newTemplateCode: null,
  newTemplateName: null,
  newTemplateMessageType: null,
  newTemplateEmphasizeType: null,
  newTemplateContent: null,
  newTemplateExtra: null,
  newTemplateImageName: null,
  newTemplateImageUrl: null,
  newTemplateTitle: null,
  newTemplateSubtitle: null,
  newTemplateHeader: null,
  newTemplateItemHighlight: null,
  newTemplateItem: null,
  newTemplateRepresentLink: null,
  templateName: null,
  templateContent: null,
  templateMessageType: null,
  templateEmphasizeType: null,
  templateExtra: null,
  templateImageName: null,
  templateImageUrl: null,
  templateHeader: null,
  templateItemHighlight: null,
  templateItem: null,
  templateRepresentLink: null,
  // categoryCode: "",
  templateTitle: null,
  templateSubtitle: null,
  // senderKeyType: "",
  securityFlag: null,
  buttons: [],
  quickReplies: [],
  // wide: "",
  // mmsAttach: {},
};

export const mmsBase = {
  mmsContent: "",
  callback: "",
  subject: "",
};

export const buttonBaseCenter = {
  name: "",
  type: "",
  url_mobile: "",
  url_pc: "",
  scheme_android: "",
  scheme_ios: "",
  chat_event: "",
};
export const buttonBaseMessage = {
  name: "",
  linkType: "",
  ordering: "",
  linkMo: "",
  linkPc: "",
  linkAnd: "",
  linkIos: "",
};

export const quickReplyBaseCenter = {
  name: "",
  type: "",
  url_mobile: "",
  url_pc: "",
  scheme_android: "",
  scheme_ios: "",
  chat_event: "",
};
export const quickReplyBaseMessage = {
  name: "",
  linkType: "",
  ordering: "",
  linkMo: "",
  linkPc: "",
  linkAnd: "",
  linkIos: "",
};

export const templateItemHighlightBase = {
  title: "",
  description: "",
  imageUrl: "",
};

export const templateItemBase = {
  list: [],
  summary: {
    title: "",
    description: "",
  },
};

export const templateItemListBase = {
  title: "",
  description: "",
};

export const templateRepresentLinkBase = {
  linkAnd: "",
  linkIos: "",
  linkPc: "",
  linkMo: "",
};
